<template>
  <v-container>
    <p class="font-weight-bold">Cari Voucher Pengajuan Cash</p>
    <v-text-field
      v-model="search"
      label="Search by keyword"
      class="mb-3"
      prepend-icon="mdi-magnify"
      hint="Detail atau Nama"
    ></v-text-field>
  <v-btn :color="buttonColor ? '' : 'white'" :class="buttonColor ? 'primary-background white--text' : 'white'" @click="searchReceipts()" light block class="font-weight-bold text-capitalize primary-color" height="50">Temukan Data</v-btn>
</v-container>
</template>

<script>

import axios from 'axios'
import { mapActions , mapGetters, mapMutations } from 'vuex'
export default {
  data: () => ({
    search: '',
    menu: false,
    modal: false,
    menu2: false,
  }),
  props : ['button-color'],
  mounted(){
  },
  computed : {
    ...mapGetters({
      receipts : 'Forms/receipts',
      user : 'Auth/user'
    })
  },
  mounted () {
  },
  methods : {
    ...mapActions({
      'getReceipts' : 'Forms/getReceipts'
    }),
    ...mapMutations({
      SET_RECEIPTS : 'Forms/SET_RECEIPTS'
    }),
    async searchReceipts () {
      if(this.search){
        await this.getReceipts({id : this.user.id})
        var result = await this.receipts.filter(item => item.sender.name.toLowerCase().indexOf(this.search) >= 0 || item.cash_receipt.details.toLowerCase().indexOf(this.search) >= 0)
        this.SET_RECEIPTS(result);
      } else {
        await this.getReceipts({id : this.user.id})
      }
    }
  }
}
</script>

<style>

</style>